<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false" :class-name="z100000">
      <h3 slot="header" class="modal-header">房型配置</h3>
          <Checkbox class="item mb16"  v-for="item in configData"  :key="item.facilitiesTypeCode" v-model="item.isSelected">{{item.facilitiesName}}</Checkbox>
    </Modal>
  </div>
</template>

<script>
  import { getFacilities,saveFacilities} from "api/houseTypeConfig";
  import {deepClone} from "@/utils/format";

  export default {
    name: "PublicConfig",
    props:{
      n: {
        type: Number,
        default: 0
      },
      houseTypeFid:{
        type:String,
        default:''
      },
      labelFid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.configData=[]
        this.getFacilities()
        this.isShow=true
      },
    },
    data(){
      return {
        isShow:false,
        configData:[],
        loading:true,
        z100000: 'z100000'
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        let ret=[]
        // console.log(this.configData)
        this.configData.forEach( item => {
          if(item.isSelected) {
           // console.log(item.isSelected)
            ret.push({
              facilitiesCode:item.facilitiesCode,
              facilitiesName:item.facilitiesName
            })
          }
        })
       
        if(ret.length<1){
          this.$Message.info('房型配置数不能为少于1')
          this.changeLoading()
          return
        }
        
        let params={
          moduleFid:this.houseTypeFid,
          labelFid:this.labelFid,
          facilitiesTypeDtoList:ret
        }
       
        saveFacilities(params).then(res=>{
          this.$Message.success("配置成功")
          this.isShow=false
        })      
      },
      getFacilities(){
        if(!this.houseTypeFid){
          return
        }
        let params={
          houseTypeFid:this.houseTypeFid,
          labelFid:this.labelFid
        }
        getFacilities(params).then(res=>{
          this.configData=res.data
          //console.log(res.data)
        })
      }
    },

  }
</script>

<style scoped>
  .item{
    margin-right: 20px;
  }
  .left,.right{
    display: inline-block;
  }
  .left{
    margin-right: 10px;
    width: 60px;
    text-align: right;
  }

</style>
